{
    "v": "4.8.0",
    "meta": { "g": "LottieFiles AE 3.5.6", "a": "", "k": "", "d": "", "tc": "" },
    "fr": 25,
    "ip": 0,
    "op": 75,
    "w": 500,
    "h": 500,
    "nm": "08 Explore",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "parent": 12,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Deslizador",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 24, "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Highlight Width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 2,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Deslizador",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 18, "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Base Color",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 3,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": [0, 0, 0, 1], "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Highlight",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 4,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 1
                            }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 75,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Plane",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.2], "y": [1] },
                            "o": { "x": [0.6], "y": [0] },
                            "t": 3,
                            "s": [0]
                        },
                        {
                            "i": { "x": [0.2], "y": [1] },
                            "o": { "x": [0.6], "y": [0] },
                            "t": 19,
                            "s": [-44]
                        },
                        {
                            "i": { "x": [0.2], "y": [1] },
                            "o": { "x": [0.6], "y": [0] },
                            "t": 37,
                            "s": [-13]
                        },
                        {
                            "i": { "x": [0.2], "y": [1] },
                            "o": { "x": [0.6], "y": [0] },
                            "t": 55,
                            "s": [-38]
                        },
                        { "t": 71, "s": [0] }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.6, "y": 0 },
                            "t": 3,
                            "s": [50, 50, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.6, "y": 0 },
                            "t": 19,
                            "s": [90, 0, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.6, "y": 0 },
                            "t": 37,
                            "s": [-2, 82, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.6, "y": 0 },
                            "t": 55,
                            "s": [50, 66, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        { "t": 71, "s": [50, 50, 0] }
                    ],
                    "ix": 2
                },
                "a": { "a": 0, "k": [250, 250, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.2, "y": 1 },
                                        "o": { "x": 0.6, "y": 0 },
                                        "t": 3,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-110.666, 24.757],
                                                    [110.667, -24.757]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.2, "y": 1 },
                                        "o": { "x": 0.6, "y": 0 },
                                        "t": 19,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-110.666, 24.757],
                                                    [110.667, -24.757]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.2, "y": 1 },
                                        "o": { "x": 0.6, "y": 0 },
                                        "t": 37,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-110.666, 24.757],
                                                    [110.667, -24.757]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.2, "y": 1 },
                                        "o": { "x": 0.6, "y": 0 },
                                        "t": 55,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-110.666, 24.757],
                                                    [110.667, -24.757]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 71,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-110.666, 24.757],
                                                    [110.667, -24.757]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.160297558354, 0.160427557253, 0.160523193958, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Base Color')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Deslizador');"
                            },
                            "lc": 1,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [320.415, 275.169], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.2, "y": 1 },
                                        "o": { "x": 0.6, "y": 0 },
                                        "t": 3,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [110.667, 24.757],
                                                    [-110.666, -24.757]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.2, "y": 1 },
                                        "o": { "x": 0.6, "y": 0 },
                                        "t": 19,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [110.667, 24.757],
                                                    [-110.666, -24.757]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.2, "y": 1 },
                                        "o": { "x": 0.6, "y": 0 },
                                        "t": 37,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [110.667, 24.757],
                                                    [-110.666, -24.757]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.2, "y": 1 },
                                        "o": { "x": 0.6, "y": 0 },
                                        "t": 55,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [110.667, 24.757],
                                                    [-110.666, -24.757]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 71,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [110.667, 24.757],
                                                    [-110.666, -24.757]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.160297558354, 0.160427557253, 0.160523193958, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Base Color')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Deslizador');"
                            },
                            "lc": 1,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [320.415, 225.655], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.2, "y": 1 },
                                        "o": { "x": 0.6, "y": 0 },
                                        "t": 3,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-81.256, -140.077],
                                                    [-81.256, -49.514],
                                                    [-140.078, 0],
                                                    [-81.256, 49.515],
                                                    [-81.256, 140.077],
                                                    [140.077, 0]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.2, "y": 1 },
                                        "o": { "x": 0.6, "y": 0 },
                                        "t": 19,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-105.187, -107.408],
                                                    [-81.256, -49.514],
                                                    [-140.078, 0],
                                                    [-81.256, 49.515],
                                                    [-113.925, 116.145],
                                                    [140.077, 0]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.2, "y": 1 },
                                        "o": { "x": 0.6, "y": 0 },
                                        "t": 37,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-65.61, -159.881],
                                                    [-81.256, -49.514],
                                                    [-140.078, 0],
                                                    [-81.256, 49.515],
                                                    [-64.281, 153.488],
                                                    [140.077, 0]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.2, "y": 1 },
                                        "o": { "x": 0.6, "y": 0 },
                                        "t": 55,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-85.89, -126.716],
                                                    [-81.256, -49.514],
                                                    [-140.078, 0],
                                                    [-81.256, 49.515],
                                                    [-96.198, 133.098],
                                                    [140.077, 0]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 71,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-81.256, -140.077],
                                                    [-81.256, -49.514],
                                                    [-140.078, 0],
                                                    [-81.256, 49.515],
                                                    [-81.256, 140.077],
                                                    [140.077, 0]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.160297558354, 0.160427557253, 0.160523193958, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Base Color')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Deslizador');"
                            },
                            "lc": 1,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [291.004, 250.412], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 3",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 1125,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Lines 1",
            "parent": 2,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.6, "y": 0 },
                            "t": 2,
                            "s": [120.526, 221.19, 0],
                            "to": [-4.461, -4.398, 0],
                            "ti": [4.461, 4.398, 0]
                        },
                        { "t": 22, "s": [93.758, 194.799, 0] }
                    ],
                    "ix": 2
                },
                "a": { "a": 0, "k": [120.526, 221.19, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-15.067, -15.066],
                                        [15.066, 15.066]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": { "a": 0, "k": 0, "ix": 1 },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.2], "y": [1] },
                                        "o": { "x": [0.6], "y": [0] },
                                        "t": 2,
                                        "s": [100]
                                    },
                                    { "t": 22, "s": [0] }
                                ],
                                "ix": 2
                            },
                            "o": { "a": 0, "k": 0, "ix": 3 },
                            "m": 1,
                            "ix": 2,
                            "nm": "Recortar trazados 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Deslizador');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [105.46, 206.123], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 2",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": -2,
            "op": 17,
            "st": -2,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Lines 2",
            "parent": 2,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.6, "y": 0 },
                            "t": 4,
                            "s": [112.004, 250.412, 0],
                            "to": [-6.204, 0.477, 0],
                            "ti": [6.204, -0.477, 0]
                        },
                        { "t": 24, "s": [74.778, 253.273, 0] }
                    ],
                    "ix": 2
                },
                "a": { "a": 0, "k": [112.004, 250.412, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [69.389, 250.412],
                                        [112.004, 250.412]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": { "a": 0, "k": 0, "ix": 1 },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.2], "y": [1] },
                                        "o": { "x": [0.6], "y": [0] },
                                        "t": 4,
                                        "s": [100]
                                    },
                                    { "t": 24, "s": [0] }
                                ],
                                "ix": 2
                            },
                            "o": { "a": 0, "k": 0, "ix": 3 },
                            "m": 1,
                            "ix": 2,
                            "nm": "Recortar trazados 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Deslizador');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 3",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": -2,
            "op": 18,
            "st": -2,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 4,
            "nm": "Lines 3",
            "parent": 2,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.6, "y": 0 },
                            "t": 6,
                            "s": [120.526, 279.634, 0],
                            "to": [-3.872, 4.439, 0],
                            "ti": [3.872, -4.439, 0]
                        },
                        { "t": 26, "s": [97.295, 306.267, 0] }
                    ],
                    "ix": 2
                },
                "a": { "a": 0, "k": [120.526, 279.634, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-15.067, 15.066],
                                        [15.066, -15.066]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Deslizador');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [105.46, 294.7], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": { "a": 0, "k": 0, "ix": 1 },
                    "e": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.2], "y": [1] },
                                "o": { "x": [0.6], "y": [0] },
                                "t": 6,
                                "s": [100]
                            },
                            { "t": 26, "s": [0] }
                        ],
                        "ix": 2
                    },
                    "o": { "a": 0, "k": 0, "ix": 3 },
                    "m": 1,
                    "ix": 2,
                    "nm": "Recortar trazados 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": -2,
            "op": 18,
            "st": -2,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "Lines 10",
            "parent": 2,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.6, "y": 0 },
                            "t": 33,
                            "s": [120.526, 221.19, 0],
                            "to": [-4.461, -4.398, 0],
                            "ti": [4.461, 4.398, 0]
                        },
                        { "t": 53, "s": [93.758, 194.799, 0] }
                    ],
                    "ix": 2
                },
                "a": { "a": 0, "k": [120.526, 221.19, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-15.067, -15.066],
                                        [15.066, 15.066]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.2], "y": [1] },
                                        "o": { "x": [0.6], "y": [0] },
                                        "t": 17,
                                        "s": [100]
                                    },
                                    { "t": 33, "s": [0] }
                                ],
                                "ix": 1
                            },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.2], "y": [1] },
                                        "o": { "x": [0.6], "y": [0] },
                                        "t": 33,
                                        "s": [100]
                                    },
                                    { "t": 53, "s": [0] }
                                ],
                                "ix": 2
                            },
                            "o": { "a": 0, "k": 0, "ix": 3 },
                            "m": 1,
                            "ix": 2,
                            "nm": "Recortar trazados 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0, 0, 0, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Base Color')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Deslizador');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [105.46, 206.123], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 2",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 25,
            "op": 46,
            "st": 21,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "Lines 11",
            "parent": 2,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.6, "y": 0 },
                            "t": 36,
                            "s": [120.526, 221.19, 0],
                            "to": [-4.461, -4.398, 0],
                            "ti": [4.461, 4.398, 0]
                        },
                        { "t": 56, "s": [93.758, 194.799, 0] }
                    ],
                    "ix": 2
                },
                "a": { "a": 0, "k": [120.526, 221.19, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-36.127, 44.479],
                                        [5.7, 44.382]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.2], "y": [1] },
                                        "o": { "x": [0.6], "y": [0] },
                                        "t": 20,
                                        "s": [100]
                                    },
                                    { "t": 36, "s": [0] }
                                ],
                                "ix": 1
                            },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.2], "y": [1] },
                                        "o": { "x": [0.6], "y": [0] },
                                        "t": 36,
                                        "s": [100]
                                    },
                                    { "t": 56, "s": [0] }
                                ],
                                "ix": 2
                            },
                            "o": { "a": 0, "k": 0, "ix": 3 },
                            "m": 1,
                            "ix": 2,
                            "nm": "Recortar trazados 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0, 0, 0, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Base Color')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Deslizador');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [105.46, 206.123], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 2",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 25,
            "op": 49,
            "st": 24,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "Lines 9",
            "parent": 2,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.6, "y": 0 },
                            "t": 39,
                            "s": [120.526, 221.19, 0],
                            "to": [-4.461, -4.398, 0],
                            "ti": [4.461, 4.398, 0]
                        },
                        { "t": 59, "s": [93.758, 194.799, 0] }
                    ],
                    "ix": 2
                },
                "a": { "a": 0, "k": [120.526, 221.19, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-14.415, 104.241],
                                        [16.826, 72.14]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.2], "y": [1] },
                                        "o": { "x": [0.6], "y": [0] },
                                        "t": 23,
                                        "s": [100]
                                    },
                                    { "t": 39, "s": [0] }
                                ],
                                "ix": 1
                            },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.2], "y": [1] },
                                        "o": { "x": [0.6], "y": [0] },
                                        "t": 39,
                                        "s": [100]
                                    },
                                    { "t": 59, "s": [0] }
                                ],
                                "ix": 2
                            },
                            "o": { "a": 0, "k": 0, "ix": 3 },
                            "m": 1,
                            "ix": 2,
                            "nm": "Recortar trazados 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0, 0, 0, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Base Color')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Deslizador');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [105.46, 206.123], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 2",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 28,
            "op": 52,
            "st": 27,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 9,
            "ty": 4,
            "nm": "Lines 6",
            "parent": 2,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [120.526, 221.19, 0], "ix": 2 },
                "a": { "a": 0, "k": [120.526, 221.19, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [15.066, 15.066],
                                        [-15.067, -15.066]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": { "a": 0, "k": 0, "ix": 1 },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.2], "y": [1] },
                                        "o": { "x": [0.6], "y": [0] },
                                        "t": 47,
                                        "s": [0]
                                    },
                                    { "t": 65, "s": [100] }
                                ],
                                "ix": 2
                            },
                            "o": { "a": 0, "k": 0, "ix": 3 },
                            "m": 1,
                            "ix": 2,
                            "nm": "Recortar trazados 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Deslizador');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [105.46, 206.123], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 2",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 53,
            "op": 76,
            "st": 44,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 10,
            "ty": 4,
            "nm": "Lines 5",
            "parent": 2,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [112.004, 250.412, 0], "ix": 2 },
                "a": { "a": 0, "k": [112.004, 250.412, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [112.004, 250.412],
                                        [69.389, 250.412]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": { "a": 0, "k": 0, "ix": 1 },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.2], "y": [1] },
                                        "o": { "x": [0.6], "y": [0] },
                                        "t": 49,
                                        "s": [0]
                                    },
                                    { "t": 67, "s": [100] }
                                ],
                                "ix": 2
                            },
                            "o": { "a": 0, "k": 0, "ix": 3 },
                            "m": 1,
                            "ix": 2,
                            "nm": "Recortar trazados 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Deslizador');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 3",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 53,
            "op": 76,
            "st": 44,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 11,
            "ty": 4,
            "nm": "Lines 4",
            "parent": 2,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [120.526, 279.634, 0], "ix": 2 },
                "a": { "a": 0, "k": [120.526, 279.634, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [15.066, -15.066],
                                        [-15.067, 15.066]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Deslizador');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [105.46, 294.7], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": { "a": 0, "k": 0, "ix": 1 },
                    "e": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.2], "y": [1] },
                                "o": { "x": [0.6], "y": [0] },
                                "t": 51,
                                "s": [0]
                            },
                            { "t": 69, "s": [100] }
                        ],
                        "ix": 2
                    },
                    "o": { "a": 0, "k": 0, "ix": 3 },
                    "m": 1,
                    "ix": 2,
                    "nm": "Recortar trazados 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": 55,
            "op": 76,
            "st": 44,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 12,
            "ty": 3,
            "nm": "Zero | troke width - Color Ctrl",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ip": 0,
            "op": 75,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
